import {useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/scss/app.scss';
import Header from './components/Header';
import Navigation from './components/parts/Navigation';
import AboutMe from './components/AboutMe';
import Expertise from './components/Expertise';
import Projects from './components/Projects';
import Resume from './components/Resume';
//import GitHub from './components/GitHub';
import Contact from './components/Contact';
import Title from './components/parts/Title';

function App() {
    let [pageData, setPageData] = useState({});

    useEffect(() => {
        fetch('https://kumardesai.com/wp-json/wp/v2/pages?acf_format=standard')
        //fetch('http://localhost:10046/wp-json/wp/v2/pages/?acf_format=standard')
            .then(response => response.json())
            .then(data => {
                let processedData = {header:{},about:{},expertise:{},projects:{},resume:{},contact:{}};
                processedData.header = data.find((item) => (item.slug=='header'));
                processedData.about = data.find((item) => (item.slug=='about'));
                processedData.expertise = data.find((item) => (item.slug=='expertise'));
                processedData.projects = data.find((item) => (item.slug=='projects'));
                processedData.resume = data.find((item) => (item.slug=='resume'));
                //processedData.github = data.find((item) => (item.slug=='github'));
                processedData.contact = data.find((item) => (item.slug=='contact'));
                console.log('%c processedData.expertise: %o', 'color: red;font-size:12px', processedData.expertise);
                setPageData(processedData);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, []);
    

    return (
        <div className="App">
            <Header data={pageData.header}/>
            <Navigation data={pageData} />

            <Title data={pageData.about}/>  
            <AboutMe data={pageData.about} />
            
            <Title data={pageData.expertise}/>  
            <Expertise data={pageData.expertise} />
            
            <Title data={pageData.projects}/>  
            <Projects/>
            
            <Title data={pageData.resume}/>  
            <Resume />
            
            {/* <Title data={pageData.github}/>
            <GitHub /> */}
            
            <Title data={pageData.contact}/>  
            <Contact />
        </div>
    );
}

export default App;
